const section = document.querySelector(".jolly-header");
const mobileMenu = section.querySelector(".jolly-header__mobile-menu");
section.addEventListener("click", (e) => {
  if (e.target.hasAttribute("data-open")) {
    mobileMenu.classList.add("open");
  } else if (e.target.hasAttribute("data-close")) {
    mobileMenu.classList.remove("open");
  } else if (e.target.hasAttribute("data-trigger")) {
    if (e.target.getAttribute("data-trigger") === "localization") {
      e.target.classList.toggle("open");
    } else if (e.target.getAttribute("data-trigger") === "country") {
      const form = e.target.closest("form");
      form.querySelector("input[name='country_code']").value = e.target.dataset.value;
      form.submit();
    }
  }
});
window.addEventListener("click", (e) => {
  if (!e.target.closest(".jolly-header__country")) {
    document.querySelector(".jolly-country__current.open")?.classList.remove("open");
  }
})

window.addEventListener("click", (e) => {
  const isClickInsideMenu = section.contains(e.target);
  const isMenuOpen = mobileMenu.classList.contains("open");

  if (isMenuOpen && !isClickInsideMenu) {
    mobileMenu.classList.remove("open");
  }
});

function clampCenteredSubmenu() {
  const items = document.querySelectorAll('.has-submenu');

  items.forEach((item) => {
    const submenu = item.querySelector('.jolly-header__submenu-wrapper');
    if (!submenu) return;

    item.addEventListener('mouseenter', () => {
      // Default centered
      submenu.style.transform = 'translateX(-50%) translateY(-10px)';

      const submenuRect = submenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      let shift = 0;

      const overflowRight = submenuRect.right - viewportWidth;
      const overflowLeft = submenuRect.left;

      if (overflowRight > 0) {
        shift = -overflowRight - 8;
      } else if (overflowLeft < 0) {
        shift = -overflowLeft + 8;
      }

      if (shift !== 0) {
        submenu.style.transform = `translateX(calc(-50% + ${shift}px)) translateY(-10px)`;
      }
    });

    item.addEventListener('mouseleave', () => {
      submenu.style.transform = 'translateX(-50%) translateY(-10px)';
    });
  });
}

clampCenteredSubmenu();
